<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title=" Laporan Kutipan Hasil Mengikut Kod Akaun">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                        <z-lookup v-if="show_jabatan == true"
                            label="Jabatan"
                            :url="service_kutipan + 'lookup/jabatan_user'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>BIL</td>
                                <td>KOD AKAUN</td>
                                <td>PERIHAL</td>
                                <td>KUTIPAN (RM)</td>
                                <td>PELARASAN (RM)</td>
                                <td>JUMLAH (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="(table.hasil_items) || (table.liabiliti_items) ">
                                <tr>
                                    <td colspan="7"><b>HASIL</b></td>
                                </tr>
                                <tr v-for="(dt, index) in table.hasil_items">
                                    <td>{{ dt.no }}</td>
                                    <td>{{ dt.kod_akaun }}</td>
                                    <td>{{ dt.perihal }}</td>
                                    <td style="text-align: right">{{ dt.amaun_kaunter }}</td>
                                    <td style="text-align: right">{{ dt.pelarasan_debit }}</td>
                                    <td style="text-align: right">{{ dt.jumlah_amaun }}</td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>JUMLAH</b></td>
                                    <td style="text-align: right"><b>{{table.total_hasil}}</b></td>
                                    <td style="text-align: right"><b>{{table.total_debit_hasil}}</b></td>
                                    <td style="text-align: right"><b>{{table.total_hasil_after_pelarasan}}</b></td>
                                </tr>
                                <tr>
                                    <td colspan="7"><b>LIABILITI</b></td>
                                </tr>
                                <tr v-for="(dt, index) in table.liabiliti_items">
                                    <td>{{ dt.no }}</td>
                                    <td>{{ dt.kod }}</td>
                                    <td>{{ dt.perihal }}</td>
                                    <td style="text-align: right">{{ dt.amaun_kaunter }}</td>
                                    <td style="text-align: right">{{ dt.pelarasan_debit }}</td>
                                    <td style="text-align: right">{{ dt.jumlah_amaun }}</td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>JUMLAH</b></td>
                                    <td style="text-align: right"><b>{{table.total_liabiliti}}</b></td>
                                    <td style="text-align: right"><b>{{table.total_debit_liabiliti}}</b></td>
                                    <td style="text-align: right"><b>{{table.total_liabiliti_after_pelarasan}}</b></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>JUMLAH KESELURUHAN</b></td>
                                    <td style="text-align: right"><b>{{table.total_keseluruhan}}</b></td>
                                    <td style="text-align: right"><b>{{table.total_keseluruhan_debit}}</b></td>
                                    <td style="text-align: right"><b>{{table.total_keseluruhan_after_pelarasan}}</b></td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="6" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <!-- <w-card class="text-right">
                        <w-flex
                            v-if="table.meta.current_page"
                            class="justify-start align-center"
                        >
                            <pagination
                                class="xs11"
                                :max="table.meta.last_page"
                                :path="table.meta.path"
                                :current="table.meta.current_page"
                                :last_page="table.meta.last_page"
                                :links="table.meta.links"
                                @pageChanged="table.loadpg"
                            />
                        </w-flex>
                    </w-card> -->
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
        show_jabatan: [Array, Object, String],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/dummy",
            reload: true,
            loading: false,
            status: [
                {
                    value: 1,
                    label: "Aktif",
                },
                {
                    value: 2,
                    label: "Tidak Aktif",
                },
            ],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/mengikut_kod_akaun"},
                { label: "Laporan", route: "/kutipan/laporan/mengikut_kod_akaun"},
                {
                    label: "Laporan Kutipan Hasil Mengikut Kod Akaun",
                    route: "/kutipan/laporan/mengikut_kod_akaun",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" },
        };
    },
    methods: {
        search() {
            this.getDataQuery();
            // this.$inertia.visit(
            //     window.route("kutipan.laporan.mengikut_kod_akaun") + 
            //         "?tarikh_dari=" + this.cari.tarikh_dari +
            //         "&tarikh_hingga=" + this.cari.tarikh_hingga+
            //         "&jabatan_id=" + this.cari.jabatan_id,
            //     { preserveScroll: true }
            // );
        },

        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "" };
            this.search();
        },

        cetak() {
            window.open(this.service_laporan+'kutipan/laporan/kod_akaun?user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga+
            "&jabatan_id=" + this.cari.jabatan_id+
            '&cetak=1','_blank');
            },
        async getDataQuery() {
            this.loading = true;
            const resp = await axios.get(
                this.service_laporan + "kutipan/laporan/kod_akaun?user_id=" + this.auth.user.id +
                    "&tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&jabatan_id=" + this.cari.jabatan_id
            );
            this.table = resp.data.data;
            this.loading = false;
        },
    },
    watch: {},
    mounted() {
        // console.log(this.datas);
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
        // console.log(this.auth.user.id);
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
